import { publicApi } from './index';

export interface CreatePromotionalGiftRequest {
  email: string;
}

export interface CreatePromotionalGiftResponse {
  message: string;
  gift: {
    [key: string]: any;
  };
  signature: string;
}

export const publicPromotionalApi = publicApi
  .enhanceEndpoints({
    addTagTypes: ['PromotionalGift'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getPromoCodeDetails: builder.query({
        query: (promoGiftCodeId) =>
          `/promotional/promo-code/${promoGiftCodeId}`,
      }),
      createPromotionalGift: builder.mutation<
        CreatePromotionalGiftResponse,
        CreatePromotionalGiftRequest
      >({
        query: (body) => ({
          url: '/promotional/gift',
          method: 'POST',
          body,
        }),
        invalidatesTags: ['PromotionalGift'],
      }),
    }),
  });

export const {
  useCreatePromotionalGiftMutation,
  useGetPromoCodeDetailsQuery,
  useLazyGetPromoCodeDetailsQuery,
} = publicPromotionalApi;
